<template>
	<div id="footer">
		<div class="content">
			<div class="footer_top">
				<div class="flex_1 flex flex_jc_sb">
					<div>
						<p class="title">美国普顿教育历史</p>
						<ul>
							<li class="pointer" v-for="(item,index) in aboutList" :key="index" @click="toPage(item.path)">{{item.name}}</li>
						</ul>
					</div>
					<!-- <div v-if="newsList.length>0">
						<p class="title">最新消息</p>
						<ul>
							<li class="pointer" v-for="(item,index) in newsList" :key="index" @click="toNewPage(item.path)">{{item.name}}</li>
						</ul>
					</div> -->
					<div v-if="activityList.length>0">
						<p class="title">推荐课外活动</p>
						<ul>
							<li class="pointer" v-for="(item,index) in activityList" :key="index" @click="toLink(item.link)">{{item.title}}</li>
						</ul>
					</div>
					<div>
						<p class="title">联系我们</p>
						<ul class="contact">
							<li>深圳南山区卓越后海中心1804室</li>
							<li>(86) 4008-958-658</li>
							<li>info@princetonow.com</li>
						</ul>
					</div>
				</div>
				<img src="../assets/images/pd.png" width="220" style="margin-left:260px;margin-right:20px">
			</div>

			<div class="copyright_wrap">
				<div class="flex flex_ai_c">
					<!-- <a href="https://beian.miit.gov.cn" target="_blank" style="color:#5f6464;margin-right:30px">粤ICP备20008933号</a> -->
					<p>Copyright © {{year}} PrincetoNow. </p>
				</div>
				<!-- <div class="flex"> -->
				<p>
					<span class="nav" @click="$router.push({path:'/about'})">关于普顿</span>
					<span> · </span>
					<span class="nav" @click="$router.push({path:'/services'})">服务</span>
					<span> · </span>
					<!-- <span class="nav" @click="$router.push({path:'/research'})">特色活动</span> -->
					<!-- <span> · </span> -->
					<span class="nav" @click="$router.push({path:'/case'})">橙果</span>
					<span> · </span>
					<span class="nav" @click="$router.push({path:'/results'})">数据</span>
					<span> · </span>
					<span class="nav" @click="$router.push({path:'/rsi'})">RSI</span>
					<span> · </span>
					<span class="nav" @click="$router.push({path:'/contactUs'})">联系我们</span>
				</p>
					<!-- <img src="../assets/images/weixin.jpg" width="60"> -->
				<!-- </div> -->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Footer",
	data() {
		return {
			year: '',
			aboutList: [
				{ name:'美国普顿教育大事记', path: '/about',},
				{ name:'普顿的做法', path: '/services/president',},
				{ name:'普顿教育橙果', path: '/case',},
			],
			newsList: [],
			activityList: [],
		}
	},
	created() {
		this.year = new Date().getFullYear()
		this.getNewsList()
		this.getActList()
	},
	methods: {
		getNewsList() {
            this.$get('/category/list').then(res=>{
                if(res.errcode===0) {
                    let arr = []
                    res.content.data.forEach(c=>{
                        let path = { id: c, name: c+'年录取消息', path: '/case/record/'+c }
                        arr.push(path)
                    })
					this.newsList = arr.splice(0,5)
                }
            })
        },
		getActList() {
			this.$get('/activity/list').then(res=>{
				if(res.errcode===0) {
					this.activityList = res.content.data
				}
			})
		},
		toPage(path) {
			if(!path) return
			this.$router.push({path})
		},
		toNewPage(path) {
			if(!path) return
			let {href} = this.$router.resolve({path})
			window.open(href, '_blank')
		},
		toLink(path) {
			if(!path) return
			window.open(path, '_blank')
		}
	}
};
</script>

<style lang="scss" scoped>
#footer {
	width: 100%;
	color: #000;
	background: #fbfbfb;
	border-top: 1px solid #fbfbfb;

	.content {
		max-width: 1200px;
		margin: 0 auto;
	}

	.footer_top {
		font-size: 12px;
		padding: 110px 0;
		display: flex;
		align-items: center;
		&>div {
			&:last-child {
				li:hover {
					color: inherit;
				}
			}
		}
		.title {
			font-size: 20px;
			margin-bottom: 55px;
			color: #5f6464;
			font-family: 'FZCu_Yahei_Jian';
		}
		li {
			list-style: none;
			font-size: 14px;
			margin-bottom: 35px;
			color: #5f6464;
			font-family: 'FZLTXIHJW';
			&:last-child { margin-bottom: 0; }
			&:hover { color: #fe9000; }
		}
		.contact {
			li:hover {color: inherit;}
		}
	}

	.copyright_wrap {
		padding: 55px 0;
		font-size: 14px;
		border-top: 1px solid #f0f0f0;
		color: #5f6464;
		display: flex;
		justify-content: space-between;
		font-family: 'FZLTXIHJW';
		
		a {
			text-decoration: none;
			&:hover { color: #fe9000; }
		}
		.qrcode {
			position: absolute;
			top: 0;
			right: 0;
			-webkit-transform: translate(130%,-50%);
			transform: translate(130%,-50%);
		}	
	}
	.nav {
		cursor: pointer;
		&:hover { color: #fe9000; }
	}
}

</style>




// WEBPACK FOOTER //
// src/components/footer.vue